// Tipos de vehículo del repartidor (campo top-level `user.vehicleType`).
// Valores en DB: sedan | suv | furgo | camion | moto.
//   - `suv` es legacy: solo se MUESTRA ("Auto / SUV"); no es seleccionable.
//   - Opciones seleccionables por el admin (4): camion, furgo, sedan, moto.
// Las etiquetas se traducen con t(); el fallback de i18n es la propia clave (español).
// Punto único de verdad reutilizado en configuración de pago, liquidación, edición y ficha.

// Orden canónico para mostrar y para las opciones seleccionables.
export const DRIVER_VEHICLE_ORDER = ["camion", "furgo", "sedan", "moto"];

// Etiquetas base (claves i18n en español). `suv` incluido solo para display legacy.
const VEHICLE_LABEL_KEYS = {
  sedan: "Auto",
  suv: "Auto / SUV",
  furgo: "Furgón",
  camion: "Camión",
  moto: "Moto",
};

// Opciones que el admin puede seleccionar (4), en orden canónico.
// `value` = valor de DB, `labelKey` = clave i18n en español.
export const DRIVER_VEHICLE_OPTIONS = DRIVER_VEHICLE_ORDER.map((value) => ({
  value,
  labelKey: VEHICLE_LABEL_KEYS[value],
}));

// Traduce un vehicleType a su etiqueta. Cubre `suv` (legacy) y null/ausente.
// Un valor no reconocido se devuelve tal cual para no ocultar datos.
export function driverVehicleLabel(value, t) {
  const tr = typeof t === "function" ? t : (s) => s;
  if (!value) return tr("Sin configurar");
  const key = VEHICLE_LABEL_KEYS[value];
  return key ? tr(key) : value;
}
